import { ArrowUpRight } from 'lucide-react';
import useInView from '@/hooks/useInView';
import useNoHover from '@/hooks/useNoHover';

interface GalleryItemProps {
  src: string;
  alt: string;
  title: string;
  onOpen: () => void;
}

export default function GalleryItem({ src, alt, title, onOpen }: GalleryItemProps) {
  const noHover = useNoHover();
  const { ref, inView } = useInView<HTMLButtonElement>(0.35);

  // On touch devices there is no hover, so the caption + arrow light up on scroll instead.
  const revealed = noHover && inView;

  return (
    <button
      ref={ref}
      type="button"
      onClick={onOpen}
      aria-label={`Ver serviços de manutenção: ${title}`}
      className="group relative block aspect-[4/3] w-full cursor-pointer overflow-hidden rounded-lg border border-background-200"
    >
      <img
        src={src}
        alt={alt}
        title={`${title} · Porta31 Condomínios`}
        loading="lazy"
        className={`h-full w-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-105 ${
          revealed ? 'scale-105' : 'scale-100'
        }`}
      />
      <div
        className={`absolute inset-0 flex items-end bg-gradient-to-t from-secondary-950/85 via-secondary-950/10 to-transparent transition-opacity duration-700 ease-out group-hover:opacity-100 ${
          revealed ? 'opacity-100' : 'opacity-0'
        }`}
      >
        <span className="flex w-full items-end justify-between gap-4 p-5">
          <span>
            <span className="block h-1 w-8 rounded-full bg-accent-500" />
            <span className="mt-3 block font-heading text-base font-semibold text-background-50">
              {title}
            </span>
          </span>
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-background-50/90 text-primary-700">
            <ArrowUpRight className="h-5 w-5" />
          </span>
        </span>
      </div>
    </button>
  );
}